<template>
  <div>
    <div class="pane-group">
      <div class="pane-sm" >
        <h5>Select Location</h5>
        
        <nav-item v-for="(loc, i) in [...$locations, 'CCS']" v-on:click="selectReport(loc, 'All')" 
        :class="loc === selectedLocation ? 'active' : ''" :key="i"
        >{{loc}}</nav-item>

        
        <h5>Select Department</h5>
        <nav-item class="active" v-on:click="selectReport('WGB', 'All')">All</nav-item>
        <nav-item v-for="(dep, i) in departments" v-on:click="selectReport('WGB', dep)" 
        :class="dep === selectedDepartment ? 'active' : ''" :key="i"
        >{{dep.name}}</nav-item>
        
        
      </div>

      <div class="pane">
        <h1>{{selectedLocation}} Inventory Counts</h1>
        
        <BasicTableComponent :list="list" :formatters="listFormatters" :titles="listTitles"/>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent, block-spacing */
/* global axios, i_axios, moment */
export default {
  name: 'InventoryCounts',
  async created () {
    await this.getDepartments()
    await this.selectReport()
  },
  data () { return { 
      selectedLocation: 'WGB',
      selectedDepartment: 'All',
      departments: [],
      list: [],
      listFormatters: {},
      listTitles: {},
    } 
  },
  methods: {
    getDepartments: async function(location){
      let response = await i_axios.post('/Reports/getInventoryDepartments', { location: this.selectedLocation })
      this.departments = response.data//.map( r => r.department)
    },
    selectReport: async function (location, department) {
      department = department === 'All' ? {dept_id: 'All'} : department
      this.selectedLocation = location === undefined ? this.selectedLocation : location;
      this.selectedDepartment = department === undefined ? this.selectedDepartment : department.dept_id;
      this.list = [];

      let response = await i_axios.post('/Reports/getInventoryCounts', { location: this.selectedLocation, dept_id: this.selectedDepartment })

      this.list = response.data
    }
  }, 
}
</script>

<style>
  
</style>
